import { Stack, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX, ReactNode } from 'react';
import React from 'react';

import type { BlackbaudRaisersEdgeIntegration } from '@feathr/blackbox';
import { EmptyState } from '@feathr/components';
import { cssVar } from '@feathr/hooks';

import * as styles from './RaisersEdgeTabContent.css';

interface IProps {
  integration: BlackbaudRaisersEdgeIntegration;
  /** Shown instead of the tab while the integration is not connected or paused. */
  inactiveLabel: string;
  /** Uses the wide width instead of the reading width, e.g. for a table with many columns. */
  isWide?: boolean;
  children: ReactNode;
}

function RaisersEdgeTabContent({
  children,
  inactiveLabel,
  integration,
  isWide = false,
}: Readonly<IProps>): JSX.Element {
  const theme = useMantineTheme();

  // A record exists before OAuth completes; only a connected or paused one has a Blackbaud token.
  if (!integration.isConnected && !integration.isPaused) {
    return <EmptyState label={inactiveLabel} name={'raisers-edge-tab-inactive'} />;
  }

  return (
    <Stack
      className={styles.root}
      gap={theme.spacing['4']}
      maw={cssVar(isWide ? '--content-wide-width' : '--content-extra-width')}
      mx={'auto'}
      w={'100%'}
    >
      {children}
    </Stack>
  );
}

export default observer(RaisersEdgeTabContent);
